/**
 * Regulatory / risk disclaimer — footer strip (reference: industry-standard exchange disclaimers).
 * Copy is tailored to CoinMBX / Megabyte Digispace Technologies Private Limited.
 */

const LEGAL_ENTITY = "Megabyte Digispace Technologies Private Limited";

const FOOTNOTES = [
  `Platform statistics and marketing figures are based on internal CoinMBX data unless stated otherwise.`,
  `${LEGAL_ENTITY} is registered as a Reporting Entity with the Financial Intelligence Unit – India (FIU-IND) under the Prevention of Money Laundering Act, 2002.`,
  `Virtual Digital Assets (VDAs) and crypto products are not legal tender in India and involve significant market risk.`,
  `Trading fees, supported assets, and product availability may change without prior notice.`,
  `Where margin or leveraged products are offered, terms and limits differ by asset and user eligibility.`,
];

export default function FooterDisclaimer() {
  const asOf = new Date().toLocaleDateString("en-IN", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return (
    <section
      className="mt-10 pt-8 border-t"
      style={{ borderColor: "#E2DEFA" }}
      data-testid="footer-disclaimer"
      aria-labelledby="footer-disclaimer-heading"
    >
      <h4
        id="footer-disclaimer-heading"
        className="text-[15px] font-bold text-cm-navy mb-4"
      >
        Disclaimer
      </h4>

      <p className="text-[11px] sm:text-[12px] text-cm-grey leading-[1.8] max-w-[1100px]">
        Crypto products &amp; NFTs are unregulated and can be highly risky. There may be no
        regulatory recourse for any loss from such transactions. The information and material
        contained herein are subject to change without prior notice including prices which may
        fluctuate based on market demand and supply. The material available on the site is
        proprietary to CoinMBX, its parent, Licensor and/or its affiliates and is for
        informational purposes and informed investors only. This material is not: (i) an offer,
        or solicitation of an offer, to invest in, or to buy or sell, any interests or shares,
        or to participate in any investment or trading strategy, or (ii) intended to provide
        accounting, legal, or tax advice, or investment recommendations.
      </p>

      <ul className="mt-5 space-y-2 max-w-[1100px]">
        <li className="text-[11px] sm:text-[12px] text-cm-grey leading-[1.7]">
          <span className="text-cm-navy font-semibold mr-1" aria-hidden="true">
            ^
          </span>
          Internal CoinMBX data as on {asOf}
        </li>
        {FOOTNOTES.map((note) => (
          <li
            key={note}
            className="text-[11px] sm:text-[12px] text-cm-grey leading-[1.7]"
          >
            <span className="text-cm-navy font-semibold mr-1" aria-hidden="true">
              ^
            </span>
            {note}
          </li>
        ))}
      </ul>
    </section>
  );
}
